import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import { get } from 'lodash';
import { Helmet } from 'react-helmet';
import ArticleTemplate from '../../Article/Template';
import MicrositeTemplate from '../../Microsites/Template';
import ApplicationStore from '../../../stores/ApplicationStore';
import DocumentStore from '../../../stores/DocumentStore';
import initSampleBox from '../../../browser/sampleBox';
import setInnerHtmlHooks from '../../../browser/setInnerHtmlHooks';
import ContentRenderer from '../../ContentRenderer';


class ArticlePage extends React.Component {
  constructor(props) {
    super(props);
    this.templates = {
      default: ArticleTemplate,
      microsite: MicrositeTemplate
    }
  }

  handleContentRender = (elem) => {
    this.executeEmbeddedScripts();
    initSampleBox();
    setInnerHtmlHooks(elem, this.props.isFramedMode)
  }

  executeEmbeddedScripts = () => {
    $('script', this.content).each((idx, item) => {
      if (item.src) {
        $(item).remove();
        const el = document.createElement('script');
        el.src = item.src;
        document.body.appendChild(el);
      } else {
        $.globalEval(item.text || item.textContent || item.innerHTML || '');
      }
    });
  }

  render() {
    const {
      doc,
      url
    } = this.props;

    const Template = this.templates[get(this.props, 'doc.meta.template') || 'default'];
    const docHasToc = !!get(this.props, 'doc.meta.toc');
    const docIsLoaded = !!(doc && (doc.html || doc.meta));

    return (
      <div
        className={`
          docs-article
          doc-with-sidebar
          ${docHasToc ? 'docs-with-toc' : ''}
        `}
      >
        <Helmet>
          <meta name="robots" content={get(doc, 'meta.sitemap') !== false ? 'all' : 'noindex, nofollow'} />
        </Helmet>

        <div className="document">
          <Template
            doc={doc}
            url={url}
            contentReady={docIsLoaded}
            renderContent={(templateDoc) => (
              <div ref={e => (this.content = e)}>
                <ContentRenderer
                  html={templateDoc.html}
                  meta={templateDoc.meta}
                  afterRender={this.handleContentRender}
                />
              </div>
            )}
          />
        </div>
      </div>
    );
  }
}

ArticlePage.propTypes = {
  doc: PropTypes.object,
  url: PropTypes.string.isRequired,
  isFramedMode: PropTypes.bool.isRequired
};

export default connectToStores(ArticlePage, [
  ApplicationStore,
  DocumentStore
], (context, { currentRoute: { url } }) => ({
  isFramedMode: context.getStore(ApplicationStore).isFramedMode(),
  doc: context.getStore(DocumentStore).getDocument(url),
  url
}));
